import {reportRegime} from '../../../constants/reportRegime';

const getRegimeName = (regime: string) => {

    if (regime === reportRegime['ASIC Rewrite']) {
        return 'Asic Rewrite';
    }

    if (regime === reportRegime['MAS Rewrite']) {
        return 'Mas Rewrite';
    }

    if (regime === reportRegime['OSC Rewrite']) {
        return 'Osc Rewrite';
    }

    if (regime === reportRegime['MiFIR Cp']) {
        return 'Mifir Cp';
    }

    if (regime === reportRegime['SIX Derivatives']) {
        return 'Six Derivatives';
    }

    if (regime === reportRegime['SIX Securities']) {
        return 'Six Securities';
    }

    if (regime === reportRegime['MiFIR Cb']) {
        return 'Mifir Cb';
    }

    if (regime === reportRegime['MiFIR Transparency']) {
        return 'Mifir Transparency';
    }

    return regime;
}

const hasRegimeSubregimes = (regime: string): boolean => {
    return regime === reportRegime.REFIT;
}

const reportRegimeHelper = {
    getRegimeName,
    hasRegimeSubregimes
};

export default reportRegimeHelper;
